// extracted by mini-css-extract-plugin
export var actions = "_4m-0";
export var actionsContainer = "_4m-7";
export var border = "_4m-1";
export var childFullHeight = "_4m-f";
export var collapse = "_4m-2";
export var content = "_4m-a";
export var contentChild = "_4m-e";
export var fullscreen = "_4m-c";
export var hasLeftRadius = "_4m-k";
export var headerContainer = "_4m-3";
export var headerRow = "_4m-5";
export var hidePadding = "_4m-b";
export var navCollapsedGap = "_4m-l";
export var noScrollX = "_4m-m";
export var noScrollY = "_4m-n";
export var noTopPadding = "_4m-i";
export var optOutTopPadding = "_4m-d";
export var pageMain = "_4m-j";
export var pageOuter = "_4m-g";
export var pagePadding = "_4m-8";
export var pageScroll = "_4m-9";
export var profile = "_4m-o";
export var profileContainer = "_4m-p";
export var profileImage = "_4m-q";
export var profileMain = "_4m-r";
export var profileSubtitle = "_4m-t";
export var profileTitle = "_4m-s";
export var showLeftPadding = "_4m-h";
export var tabsPortalSlot = "_4m-6";
export var tabsWrapper = "_4m-4";
export var title = "_4m-u";